import classNames from 'classnames'
import { useEffect, useMemo, useRef } from 'react'

import { AbsolutePopup, IPopupMethods, PopPaper } from 'core-components/library/popup'

import { DATE_PICKER_HORIZONTAL_OFFSET, DATE_PICKER_VERTICAL_OFFSET } from './constants'
import { getValidDate } from './helpers/getValidDate'
import { Input } from './Input'
import { IDatePicker } from './models/IDatePicker'
import { DatePickerPopup } from './Popup'

import styles from './DatePicker.module.scss'

export const DatePicker = (props: IDatePicker) => {
  const { disabled, classes, margin } = props
  const popupRef = useRef<IPopupMethods>(null)

  useEffect(() => {
    if (props._pickerVisible) {
      popupRef.current?.open()
    }
  }, [props._pickerVisible])

  const value: any = useMemo(() => {
    return getValidDate(props.value)
  }, [props.value])

  return (
    <div
      className={classNames(styles.root, classes?.controlClasses?.root, {
        [`margin-bottom-${margin}`]: !!margin,
      })}
      data-testid={'datepickerRoot'}
    >
      <AbsolutePopup
        ref={popupRef}
        popupClassName={classNames(styles.popup, classes?.controlClasses?.popup)}
        visibilityCallback={(newVisible) => {
          if (disabled) {
            return false
          }
          return newVisible
        }}
        horizontalOffset={DATE_PICKER_HORIZONTAL_OFFSET}
        verticalOffset={DATE_PICKER_VERTICAL_OFFSET}
        popupContent={(contentData) => {
          return (
            <PopPaper className={styles.paper}>
              <DatePickerPopup
                {...props}
                withTimeZone={!!props.minutesStep}
                close={contentData.action.close}
                verticalDirection={contentData.direction.vertical}
                value={value}
              />
            </PopPaper>
          )
        }}
      >
        <Input
          {...props}
          classes={{
            inputClasses: classes?.inputClasses,
            validatorClasses: classes?.validatorClasses,
          }}
          isPopupInput={false}
          value={value}
        />
      </AbsolutePopup>
    </div>
  )
}
